import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiPercent,
  FiUserPlus,
  FiUsers,
  FiSettings,
  FiFileText,
  FiBriefcase,
  FiPackage,
  FiCalendar,
  FiBell,
  FiHelpCircle,
  FiMail,
} from "react-icons/fi";

import "./SideBar.scss";

const SideBar = ({ collapsed = false }) => {
  const links = [
    {
      name: "Subscription Management",
      link: "/subscription-management",
      icon: FiSettings,
    },
    {
      name: "State And County Sales Tax",
      link: "/state-and-county-tax",
      icon: FiPercent,
    },
    {
      name: "New Lead",
      link: "/newleads",
      icon: FiUserPlus,
    },
    {
      name: "Subscription / Users",
      link: "/subscription",
      icon: FiUsers,
    },

    {
      name: "Proposal Text & Templates",
      link: "/proposal-text",
      icon: FiFileText,
    },
    {
      name: "Repair Policy & Disclaimer",
      link: "/repair-policy",
      icon: FiFileText,
    },
    {
      name: "Supplier Personnel Position",
      link: "/supplier-personnel",
      icon: FiBriefcase,
    },
    {
      name: "Resource Management",
      link: "/master-pricing",
      icon: FiPackage,
    },
    {
      name: "Scheduling Modals",
      link: "/scheduling-modal",
      icon: FiCalendar,
    },
    {
      name: "Notification",
      link: "/notification",
      icon: FiBell,
    },
    {
      name: "Help",
      link: "/help",
      icon: FiHelpCircle,
    },
    {
      name: "Client Email Template",
      link: "/clientEmailTemplate",
      icon: FiMail,
    },
  ];
  const { pathname } = useLocation();

  return (
    <nav className={`modern-sidebar ${collapsed ? "collapsed" : ""}`}>
      <ul className="sidebar-nav">
        {links.map((link) => {
          const Icon = link.icon;
          const isActive = pathname === link.link;
          
          return (
            <li key={link.name} className="sidebar-item">
              <Link
                className={`sidebar-link ${isActive ? "active" : ""}`}
                to={link.link}
                title={collapsed ? link.name : undefined}
              >
                <Icon className="sidebar-icon" />
                <span className="sidebar-text">{link.name}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SideBar;
